// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"cd524a2e","224":"d2b6abcf","228":"bb015d82","527":"e3db50a2","536":"9b8b92be","575":"57011fc7","648":"c1c667d2","709":"0e3aa5b8","724":"b0107dca","742":"0923c8a4","815":"743ab202","882":"78e8f5da","988":"354d3134"}[chunkId] + ".chunk.178768868236995333.js";
};